import {
  DvGridCoreDirective,
  DvCreationRowDirective,
  DvGridStandaloneDirective,
  DvPinSelectedRowDirective,
  DvGridInSidesheetDirective,
  DvGridWithSidesheetDirective,
  DvSuppressContextMenuDirective,
} from '@devinco/ui/grid';
import { NgModule } from '@angular/core';
import { AgGridPreferenceDirective } from '@shared/directives/preferences/ag-grid-preference-save.directive';
import { DvVerticalSplitterDirective } from '@shared/directives/vertical-splitter.directive';
import { DvGridDirective } from './grid/dv-grid.directive';
import { GridRowEditingDirective as GridRowEditingDirective } from './grid/grid-row-editing.directive';
import { GridRowSelectionDirective } from './grid/grid-row-selection.directive';
import { GridTranslateDirective } from './grid/grid-translate.directive';
import { VtSplitterDirective } from './grid/vt-splitter.directive';
import { NoTrailingSpacesInFormDirective } from './no-trailing-spaces-in-form.directive';

@NgModule({
  imports: [
    DvGridCoreDirective,
    DvCreationRowDirective,
    DvGridStandaloneDirective,
    DvPinSelectedRowDirective,
    DvGridInSidesheetDirective,
    DvGridWithSidesheetDirective,
    DvSuppressContextMenuDirective,
  ],
  declarations: [
    DvGridDirective,
    GridTranslateDirective,
    DvVerticalSplitterDirective,
    AgGridPreferenceDirective,
    GridRowEditingDirective,
    NoTrailingSpacesInFormDirective,
    GridRowSelectionDirective,
    VtSplitterDirective,
  ],
  exports: [
    DvGridCoreDirective,
    DvCreationRowDirective,
    DvGridStandaloneDirective,
    DvPinSelectedRowDirective,
    DvGridInSidesheetDirective,
    DvGridWithSidesheetDirective,
    DvSuppressContextMenuDirective,
    DvGridDirective,
    GridTranslateDirective,
    DvVerticalSplitterDirective,
    AgGridPreferenceDirective,
    GridRowEditingDirective,
    NoTrailingSpacesInFormDirective,
    GridRowSelectionDirective,
    VtSplitterDirective,
  ],
})
export class DirectivesModule {}
